import styled from "styled-components";

const CardFace = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    padding-right: 12px;
    position: relative;
`;

export default CardFace;

export const CardFace2 = styled(CardFace)`
    & > :first-child {
        font-size: 1.8em;
    }

    & > :nth-child(2) {
        font-size: .7em;
        opacity: .4;
    }
`;

export const CardFace3 = styled(CardFace)`
    & > :first-child {
        font-size: 1.8em;
    }

    & > :nth-child(2) {
        font-size: 1.2em;
    }

    & > :nth-child(3) {
        font-size: .7em;
        opacity: .6;
    }
`;
